import { Model as o } from "../../../../model.js";
class d extends o {
  constructor(e) {
    super(), this.analytics = e.analytics, this.headCode = e.headCode, this.bodyCode = e.bodyCode, this.supportedLanguages = e.supportedLanguages;
  }
}
export {
  d as CheckoutSettingsConfigurationModel
};
//# sourceMappingURL=configuration.model.js.map
